const FixedToolbar = (props) => {
	const mainClass = "help-fixed-toolbar";
	return (
		<div className={mainClass}>
			<div className={`${mainClass}__container`}>{props.children}</div>
		</div>
	);
};

export default FixedToolbar;
